import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { UserDto, UserProfileApi } from '../../../api-client';

type UseGetProfile = (
  userProfileApi: UserProfileApi,
  options: UseQueryOptions,
) => UseQueryResult<UserDto>;

const QUERY_KEY = 'userProfile';

export const useGetProfile: UseGetProfile = (userProfileApi) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useQuery([QUERY_KEY], async () =>
    userProfileApi.getUserProfile(tenantId).then((res) => res.data),
  );
};
